<script>
import { HorizontalBar  } from 'vue-chartjs'

export default {
  extends: HorizontalBar ,
  mounted () {
    this.renderChart({
      labels: [
        'EM ARTUR BERNARDES', 
        'EM GENTE INOCENTE', 
        'EM. EVALDO FONTES', 
        'EM JOAO REIS', 
        'E.M BENVINDA',
        'EMEI NOVA ESPERANÇA',
        'EM HUGO DUARTE',
        'EM ALTINA',
      ],
      datasets: [
        {
          label: 'Alunos Evadidos',
          backgroundColor: ['#4CAF50', '#FF9800', '#795548', '#42A5F5', '#FF6F00', '#B388FF', '#ff6384', '#546E7A'],
          data: [8, 2, 26, 16, 22, 15, 44, 6],
        },
      ],
    }, {
      animation: {
        duration: 1,
        onComplete() {
          var chartInstance = this.chart,
          ctx = chartInstance.ctx;

          ctx.font = Chart.helpers.fontString(Chart.defaults.global.defaultFontSize, Chart.defaults.global.defaultFontStyle, Chart.defaults.global.defaultFontFamily);
          ctx.textAlign = 'center';
          ctx.textBaseline = 'bottom';

          this.data.datasets.forEach(function(dataset, i) {
            var meta = chartInstance.controller.getDatasetMeta(i);
            meta.data.forEach(function(bar, index) {
              var data = dataset.data[index];
              ctx.fillText(data, bar._model.x + 10, bar._model.y + 6);
            });
          });
        }
      },
      scales: {
        yAxes:[{
         barPercentage: 0.3,
        }],
        xAxes:[{
          display: false,
          ticks: {
            beginAtZero: true,
            steps: 10,
            stepValue: 5,
            max: 50
          }
        }]
      },
      legend: {
        display: false
      },
      options: { 
        responsive: true, 
      },
    })
  }
}
</script>

<style>

</style>
